import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { allIcons, allImages } from "../../assets";
import appcolors from "../../constants/Colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Avatar, Box, ListItemIcon, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { t } from "i18next";

const style = {
  menuButton: {
    padding: "4px 8px",
    fontSize: "0.875rem",
    color: appcolors.slateGrey,
  },
};

export default function ProfileMenu({ styleProps, hoverProps }) {
  const naviagte = useNavigate();
  const userData = useSelector((state) => state.userData.user);


  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            {...bindTrigger(popupState)}
            variant="contained"
            disableRipple
            startIcon={
              <Avatar
                sx={{ height: 32, width: 32, border: "2px solid #ffffff" }}
                src={userData?.profileImg || allImages.dumyUserImg}
              />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor={appcolors.white}
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            sx={{
              width: 160,
              height: 45,
            }}
          >
            <Typography variant="body2" noWrap>
              {userData?.businessName || userData?.name || userData?.username}
            </Typography>
          </Button>
          <Menu
            disableScrollLock
            {...bindMenu(popupState)}
            PaperProps={{
              sx: {
                width: 160,
                maxHeight: "100% !important",
                top: "64px !important",
              },
            }}
          >
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              width={"100%"}
              p="5px"
            >
              <Avatar
                sx={{ height: 50, width: 50 }}
                src={userData?.profileImg || allImages.dumyUserImg}
              />
              <Typography
                variant="h6"
                fontSize={"0.875rem"}
                fontWeight={"400"}
                color={"primary"}
                textAlign={"center"}
                whiteSpace={"break-spaces"}
              >
                {userData?.businessName || userData?.name || userData?.username}
              </Typography>
            </Stack>
            <MenuItem
              onClick={() => {
                popupState.close();
                if (userData.role === "education") {
                  naviagte("/education/customer-support");
                } else if (userData.role === "company") {
                  naviagte("/company/customer-support");
                } else if (userData.role === "worker") {
                  naviagte("/worker/customer-support");
                } else if (userData.role === "supplier") {
                  naviagte("/supplier/customer-support");
                } else if (userData.role === "creator") {
                  naviagte("/creator/customer-support");
                } else {
                  naviagte("/customer-support");
                }
              }}
              sx={style.menuButton}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img src={allIcons.Question} alt={"setting-icon"} width={20} />
              </ListItemIcon>
              {t("contactUs")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                popupState.close();
                if (userData.role === "worker") {
                  naviagte("/worker/settings");
                } else if (userData.role === "supplier") {
                  naviagte("/supplier/settings");
                } else if (userData.role === "company") {
                  naviagte("/company/settings");
                } else if (userData.role === "education") {
                  naviagte("/education/settings");
                } else if (userData.role === "creator") {
                  naviagte("/creator/settings");
                } else {
                  naviagte("/worker/settings");
                }
              }}
              sx={style.menuButton}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img
                  src={allIcons.settingIcon}
                  alt={"setting-icon"}
                  width={19}
                />
              </ListItemIcon>
              {t("settings")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                popupState.close();
                localStorage.removeItem("user-data");
                window.location.href = "/"; // Reloads the page and navigates
              }}
              sx={{ ...style.menuButton }}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img
                  src={allIcons.logoutIcon}
                  alt={"setting-icon"}
                  width={20}
                />
              </ListItemIcon>
              {t("logout")}
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
